import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Textarea,
  Tooltip,
  useTheme,
} from '@chakra-ui/react';
import QuestionContext from './QuestionContext';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { useAutoResize } from '../../hooks/util';
import { useRef } from 'react';

const QuestionContextEditor = ({
  configs,
  updateQContextList,
  updateGeneralContext,
}) => {
  const genContextRef = useRef(null);
  useAutoResize(genContextRef);
  const theme = useTheme();

  const handleCreate = () => {
    updateQContextList([
      { title: 'New_Context', description: '', context: '' },
      ...configs.questionContextList,
    ]);
  };

  const handleDelete = (index) => {
    const newQContextList = [...configs.questionContextList];
    newQContextList.splice(index, 1);
    updateQContextList(newQContextList);
  };

  const handleChange = (index, key, value) => {
    const newQContextList = [...configs.questionContextList];
    newQContextList[index][key] = value;
    updateQContextList(newQContextList);
  };

  const handleGeneralContextChange = (e) => {
    updateGeneralContext(e.target.value);
  };

  return (
    <Box p={5} position='relative'>
      <Box mb={5}>
        <Flex alignItems='center' mb={1}>
          <Heading fontSize='24px'>General Context</Heading>
          <Tooltip label='This context is added to all prompts that interact with the database.'>
            <InfoOutlineIcon boxSize={4} ml={1} opacity='.5' />
          </Tooltip>
        </Flex>
        <Textarea
          ref={genContextRef}
          background={theme.colors.bgGrey2}
          placeholder='General Context'
          value={configs?.generalContext}
          onChange={handleGeneralContextChange}
          resize='none'
          overflow='hidden'
          height='unset'
        />
      </Box>

      <Flex alignItems='center' mb={1}>
        <Heading fontSize='24px'>Specific Question Context</Heading>
        <Tooltip label='The bot determines if the user question falls into one of these contexts. If so, the context is added to database prompts.'>
          <InfoOutlineIcon boxSize={4} ml={1} opacity='.5' />
        </Tooltip>
        <Button ml={10} colorScheme='blue' onClick={handleCreate}>
          Add New
        </Button>
      </Flex>
      {configs?.questionContextList.map((item, index) => (
        <QuestionContext
          key={index}
          name={item.title}
          description={item.description}
          context={item.context}
          handleDelete={() => handleDelete(index)}
          handleNameChange={(e) => handleChange(index, 'title', e.target.value)}
          handleDescriptionChange={(e) =>
            handleChange(index, 'description', e.target.value)
          }
          handleContextChange={(e) =>
            handleChange(index, 'context', e.target.value)
          }
        />
      ))}
    </Box>
  );
};

export default QuestionContextEditor;
